import { useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { Container, Row, Col, Image } from "react-bootstrap";
import SocialMediaRequests from "../../../../components/common/SocialMediaRequests/SocialMediaRequests";
import SMSReviewImage from "../../../../assests/images/invite-reviews-images/sms-review-image.webp";
import SmsReviewTextBoxImage from "../../../../assests/images/invite-reviews-images/sms-review-box.webp";
import ReviewUsOn from "../../../../assests/images/invite-reviews-images/review-us-on.webp";
import {
    InviteReviewTopSec,
    SocialMediaGroup,
    InviteReviewsSMSSection,
    InviteReviewsSMSWrap,
    InviteReviewsSmsTitle,
    InviteReviewsSmsText,
    InviteReviewsSmsSubTitle,
    SmsReviewWrap,
    SmsReviewImage,
    SmsReviewContent,
    SmsReviewUnorderedList,
    SmsReviewList,
    SmsReviewListStrong,
    SmsReviewTextLine,
    SmsReviewTextBox,
    WhyUseSmsSection,
    WhyUseSmsWrap,
    WhyUseSmsTitle,
    WhyUseSmsUnorderedList,
    WhyUseSmsList,
    WhyUseSmsListStrong,
    InviteClientsWrap,
    InviteClientsUnorderedList,
    InviteClientsList,
    InviteClientsStrong,
    InviteClientsImage,
    InviteClientsBox,
    InviteClientButton,
    CollectingReviewsSection,
    CollectingReviewsWrap,
    CollectingReviewsTitle,
    CollectingReviewsText,
    CollectingReviewsStrong,
    ClientCollectingReviewsBox,
    CollectingReviewsGroup,
} from "./inviteStyle";

import {
    Title,
    WriteReviewSection,
    ReviewText,
    ReviewRightSection,
    RightBanner,
} from "../../../../components/common/commonSubBanner/commonSubBannerStyle";
import InviteReviewsBanner from "../../../../assests/images/invitereviews-banner.webp"
import { useDispatch, useSelector } from "react-redux";
import { endorsementsHandler } from "../../../../redux/slices/endorsements/endorsements-slice";
import { MESSAGE } from "../../../../utils/message";
import MetaComponent from "../../../../components/common/metaComponent";

const InviteReviews = () => {
    const dispatch: any = useDispatch();
    const smsRef = useRef<HTMLDivElement | null>(null);

    const endorsementsList = useSelector((state: any) => state?.endorsements?.data);
    useEffect(() => {
        dispatch(endorsementsHandler())
    }, [])

    const scrollTo = () => {
        if (smsRef?.current) {
            smsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }

    const downloadSMSReviewTemplate = () => {
        const content = "This is sms review template demo";
        const element = document.createElement("a");
        const file = new Blob([content], { type: 'text/plain' });
        element.href = URL.createObjectURL(file);
        element.download = "sms_review.docx";
        document.body.appendChild(element);
        element.click();
    }

    return (
        <>
            <MetaComponent
                keywords=""
                description=""
                ogTitle="Invite Reviews | GreatNonprofits"
                ogDescription=""
                ogUrl="https://www.about.greatnonprofits.org/invite-reviews"
                ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
            />
            <>

                <InviteReviewTopSec>
                    <WriteReviewSection className="invite-review-banner">
                        <Container className="cont-w">
                            <Row>
                                <Col lg={6} sm={12} md={12}>
                                    <Title className="invite-reviews-title">Showcase Your Impact with Real-Time Reviews</Title>
                                    <ReviewText>
                                        Gather inspiring review from your volunteers clients and donors. Share
                                        them and your board and use them in your marketing materials. You can invite
                                        them to review your nonprofit on our website via social media or
                                        <Link to="/about/invite-reviews" onClick={scrollTo}> invite review  via SMS. </Link>
                                    </ReviewText>
                                    <ReviewText>Here are some sample invite templates you can use for social media and e-mail!</ReviewText>
                                </Col>
                                <Col lg={6} sm={12} md={12}>
                                    <RightBanner className="left_banner">
                                        <ReviewRightSection>
                                            <Image src={InviteReviewsBanner} alt="ReviewImage" />
                                        </ReviewRightSection>
                                    </RightBanner>
                                </Col>
                            </Row>
                        </Container>
                    </WriteReviewSection>
                </InviteReviewTopSec>

                <SocialMediaGroup>
                    <Container className="cont-w social-media-detail-main">
                        <Row className="social-media-req-main">
                            <Col lg="6"><SocialMediaRequests /></Col>
                            <Col lg="6"><SocialMediaRequests /></Col>
                            <Col lg="12"><SocialMediaRequests /></Col>
                        </Row>
                    </Container>
                </SocialMediaGroup>

                <InviteReviewsSMSSection>
                    <Container>
                        <Row>
                            <Col lg="12">

                                <InviteReviewsSMSWrap ref={smsRef}>
                                    <InviteReviewsSmsTitle>{MESSAGE.inviteReviewSMS}</InviteReviewsSmsTitle>
                                    <InviteReviewsSmsText>That&#8218;s right, now you can invite reviews using SMS! This is perfect to invite people to review you during live, in-person events or even post reviews on posters. Or use this when you&#8218;re meeting with clients directly.</InviteReviewsSmsText>
                                    <InviteReviewsSmsText>It&#8218;s simple to get started. You just need the nonprofit's EIN number.</InviteReviewsSmsText>
                                    <InviteReviewsSmsSubTitle>To Send an SMS Review</InviteReviewsSmsSubTitle>

                                    <SmsReviewWrap>
                                        <SmsReviewImage>
                                            <Image src={SMSReviewImage} alt="Sms Review Image" />
                                        </SmsReviewImage>

                                        <SmsReviewContent>
                                            <SmsReviewUnorderedList>
                                                <SmsReviewList>
                                                    Tap <SmsReviewListStrong>New Message</SmsReviewListStrong> on your <SmsReviewListStrong>Message</SmsReviewListStrong> app <SmsReviewListStrong>(888) 432 - 6659</SmsReviewListStrong>
                                                </SmsReviewList>

                                                <SmsReviewList>
                                                    Enter the number <SmsReviewListStrong>(888) 432 - 6659</SmsReviewListStrong>
                                                </SmsReviewList>

                                                <SmsReviewList>
                                                    In the message field, enter the <SmsReviewListStrong>9-digit EIN of the nonprofit</SmsReviewListStrong> you are writing about
                                                </SmsReviewList>

                                                <SmsReviewList>
                                                    Tap  <SmsReviewListStrong>Send</SmsReviewListStrong>
                                                </SmsReviewList>

                                                <SmsReviewList>
                                                    Now you will be given three questions: <SmsReviewListStrong>a rating, your role,</SmsReviewListStrong> <SmsReviewListStrong>and a space to </SmsReviewListStrong> write comments
                                                </SmsReviewList>

                                                <SmsReviewList>Your privacy is protected. Your answers are anonymous and your phone number is never shown publicly.</SmsReviewList>

                                            </SmsReviewUnorderedList>

                                            <SmsReviewTextLine>Reviews automatically show up on your profile page. Reviewers are designated as mobile users.</SmsReviewTextLine>

                                            <SmsReviewTextBox>
                                                <Image src={SmsReviewTextBoxImage} alt="Sms Review Text Box" />
                                            </SmsReviewTextBox>

                                        </SmsReviewContent>

                                    </SmsReviewWrap>

                                </InviteReviewsSMSWrap>

                            </Col>
                        </Row>
                    </Container>
                </InviteReviewsSMSSection>

                <WhyUseSmsSection>
                    <Container>
                        <Row>
                            <Col lg="12">
                                <WhyUseSmsWrap>
                                    <WhyUseSmsTitle>Why Use SMS?</WhyUseSmsTitle>

                                    <WhyUseSmsUnorderedList>

                                        <WhyUseSmsList><WhyUseSmsListStrong>Text reviews are automatically posted</WhyUseSmsListStrong> on GreatNonprofits.org and counted toward your community-sourced rating</WhyUseSmsList>

                                        <WhyUseSmsList><WhyUseSmsListStrong>Hear firsthand</WhyUseSmsListStrong> from clients so that you can better meet their needs.</WhyUseSmsList>

                                        <WhyUseSmsList><WhyUseSmsListStrong>SMS ratings</WhyUseSmsListStrong> are simple for your clients, fast, and convenient. No Internet needed</WhyUseSmsList>

                                    </WhyUseSmsUnorderedList>

                                </WhyUseSmsWrap>
                            </Col>
                        </Row>
                    </Container>
                </WhyUseSmsSection>

                <InviteReviewsSMSSection>
                    <Container>
                        <Row>
                            <Col lg="12">

                                <InviteReviewsSMSWrap>
                                    <InviteReviewsSmsTitle>Invite Clients to Submit a Review by Phone</InviteReviewsSmsTitle>

                                    <InviteClientsWrap>

                                        <InviteClientsBox>
                                            <InviteClientsUnorderedList>
                                                <InviteClientsList>
                                                    <InviteClientsStrong>For clients you serve:</InviteClientsStrong>
                                                    Include the flyer in materials you give to your clients (i.e. information packets or grocery bags).
                                                </InviteClientsList>

                                                <InviteClientsList>
                                                    <InviteClientsStrong>For volunteers or donors:</InviteClientsStrong>
                                                    Hand out the flyer to your volunteers or donors after your volunteering or information event.
                                                </InviteClientsList>

                                            </InviteClientsUnorderedList>

                                            <InviteClientButton>
                                                <button className="docx-template-btn" type="button" onClick={() => downloadSMSReviewTemplate()}>{MESSAGE.downloadDocxTemplate}</button>
                                            </InviteClientButton>

                                        </InviteClientsBox>

                                        <InviteClientsImage>
                                            <Image src={ReviewUsOn} alt="Sms Review Image" />
                                        </InviteClientsImage>

                                    </InviteClientsWrap>

                                </InviteReviewsSMSWrap>

                            </Col>
                        </Row>
                    </Container>
                </InviteReviewsSMSSection>

                <CollectingReviewsSection>
                    <Container>

                        <Row className="collecting-reviews-main">
                            <Col lg="12">
                                <CollectingReviewsWrap>
                                    <CollectingReviewsTitle>Ideas for Collecting Reviews</CollectingReviewsTitle>
                                    <CollectingReviewsText>Nonprofits have come up with some really creative ways to solicit reviews from their clients, volunteers, supporters and partners. Do you have an idea to share? <CollectingReviewsStrong>Send it to us!</CollectingReviewsStrong></CollectingReviewsText>
                                </CollectingReviewsWrap>
                            </Col>

                            <Col lg="12">
                                <CollectingReviewsGroup>

                                    {endorsementsList?.data?.map((endorsements: any, index: number) => (
                                        <ClientCollectingReviewsBox className="client-collecting-reviews-box" key={index + 1}>
                                            <SocialMediaRequests endorsementsData={endorsements} />
                                        </ClientCollectingReviewsBox>
                                    ))}

                                </CollectingReviewsGroup>
                            </Col>
                        </Row>
                    </Container>
                </CollectingReviewsSection>

            </></>)
};
export default InviteReviews;